var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGPay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 50,
    viewBox: "-1.269 -2.212 245.891 205.526",
    width: 50,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m208.231 34.408c-15.874-3.212-41.469-7.556-48.62 7.387-21.854 37.853-34.401 77.47-43.845 94.468.992.573 44.521 25.828 47.6 27.322 9.786 4.749 26.124 2.612 33.084-9.941 19.308-34.823 14.4-25.757 34.915-61.289 13.257-22.962-3.318-53.938-23.134-57.947z",
    fill: "#ea4335",
    strokeWidth: 0.265
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m70.89 188.08c-10.659-12.194-18.478-36.59-9.112-50.253 27.361-47.392 49.264-76.081 66.49-104.838 9.134 5.274 45.733 26.034 48.17 28.173 8.177 7.173 14.951 20.879 7.56 33.183-20.504 34.133-28.917 49.58-49.757 85.677-13.26 22.968-50.035 23.292-63.351 8.058z",
    fill: "#fdbd00",
    strokeWidth: 0.265
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.268
  }, /*#__PURE__*/React.createElement("path", {
    d: "m169.03 10.248c-21.323-12.46-32.283-10.827-43.75-8.988-10.425 2.606-24.521 10.182-30.463 19.915-14.99 24.552-29.188 48.847-47.581 81.77-5.665 10.14-1.46 22.598 3.768 27.542 3.543 3.352 29.612 17.735 34.422 19.803 6.804 2.925 16.996.89 23.144-5.438 1.698-1.748 40.588-68.547 51.54-88.249 4.623-8.314 8.787-12.915 15.7-17.35 13.355-7.008 23.782-7.912 39.753-2.072 0 0-34.76-20.148-46.533-26.933z",
    fill: "#2da94f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.833 167.014c-21.453-12.236-25.519-22.544-29.66-33.395-2.955-10.33-3.442-26.326 2.016-36.34 13.769-25.256 13.67-25.384 32.986-57.775 5.949-9.976 18.841-12.563 25.737-10.508 4.674 1.392 30.164 16.777 34.36 19.909 5.936 4.43 9.269 14.274 6.863 22.763-.665 2.344-25.032 45.108-36.617 64.445-4.89 8.16-6.792 14.066-7.176 22.27.608 15.07 5.038 24.552 18.082 35.464 0 0-34.829-20.03-46.591-26.833z",
    fill: "#297aec"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGPay);
export default __webpack_public_path__ + "static/media/GPay.3513c603190ea9e0b40a4deaa0618082.svg";
export { ForwardRef as ReactComponent };